import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { useApiClientInvestment } from '~/@api/client/useApiClientInvestment'

export const DEFAULT_MIN_ORDER_AMOUNT = 50

export type GetOrderOfferDataParams = {
  businessId: string
  stageNumber: string
}

function useOrderOfferDataQuery({
  businessId,
  stageNumber,
}: GetOrderOfferDataParams) {
  const client = useApiClientInvestment()
  const [orderAmount, setOrderAmount] = useState(
    DEFAULT_MIN_ORDER_AMOUNT.toString()
  )

  async function fetchOrderOfferData(amount = orderAmount) {
    return client.investment
      .orderControllerGetOfferData(
        Number(businessId),
        Number(stageNumber),
        { orderAmount: amount },
        { secure: true }
      )
      .then((resp) => resp.data)
  }

  const query = useQuery({
    queryKey: ['order-offer-data', businessId, stageNumber, orderAmount],
    queryFn: () => fetchOrderOfferData(orderAmount),
    placeholderData: keepPreviousData,
  })

  const reloadOrderOffer = (amount: string) => {
    setOrderAmount(amount)
  }

  return {
    ...query,
    reloadOrderOffer,
  }
}

export { useOrderOfferDataQuery }
